import { Reveal } from "@/components/Reveal";
import { PinMark } from "@/components/Brand";

export default function Trust() {
  return (
    <section id="trust" data-testid="trust-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-3xl px-5 sm:px-8 text-center">
        <Reveal>
          <div className="flex justify-center">
            <PinMark size={44} bg="#2B2B2B" tick="#2BBFB3" />
          </div>
          <p className="mt-6 overline text-[#2BBFB3]">Built by an instructor, for instructors</p>
          <h2 className="mt-6 font-display font-extrabold tracking-tight text-3xl sm:text-[2.75rem] leading-[1.08] text-[#2B2B2B]">
            DriveAssure wasn't dreamed up in a boardroom. It was built by a working driving instructor
            <span className="text-[#2B2B2B]/40"> — for their own school first.</span>
          </h2>
          <p className="mt-7 max-w-xl mx-auto text-lg text-[#2B2B2B]/60 leading-relaxed">
            Every pin, every report and every practice plan exists because a real instructor needed it
            on a real lesson. If it doesn't make your day on the road easier, it doesn't ship.
          </p>
          <div className="mt-9 inline-flex items-center gap-3 rounded-full border border-[#E5E5E5] bg-[#F7F7F7] px-5 py-2.5">
            <span className="grid place-items-center w-8 h-8 rounded-full bg-[#2B2B2B] text-[#2BBFB3] font-display font-bold text-sm">
              DA
            </span>
            <span className="text-sm font-medium text-[#2B2B2B]/70">A tool that earns its place in the car.</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
